<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          v-if="dialog.form"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                {{ message.status === 'tambah' ? 'Penambahan' : 'Pengurangan' }} Stok
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Stok" 
                    rules="required|min_value:0" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Stok yang akan {{ message.status === 'tambah' ? 'ditambahkan' : 'dikurangkan' }}
                    </div>

                    <v-currency-field              
                      rounded
                      dense
                      filled
                      hide-details

                      color="#718EBF"
                      placeholder="Qty"
                      :error-messages="errors"

                      class="mb-6"

                      v-model="form.qty"
                      
                      required
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.qty !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-currency-field>
                  </ValidationProvider>

                  <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                    Catatan
                  </div>
                  <ValidationProvider
                    name="Catatan" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <v-textarea
                      filled
                      rounded
                      dense
                      rows="3"
                      
                      hide-details
                      
                      :color="set_color"
                      placeholder="Contoh. Tuliskan catatan disini . . ."

                      v-model="form.note"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.note !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-textarea>
                  </ValidationProvider>

                  <!-- <div class="body-2 mb-2">
                    Catatan
                  </div>
                  <v-textarea
                    filled
                    rounded
                    dense
                    rows="3"
                    
                    hide-details
                    
                    :color="set_color"
                    placeholder="Contoh. Tuliskan catatan disini . . ."

                    v-model="form.qty_diterima_note"
                    style="border-radius: 10px;">
                  </v-textarea> -->
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">Resep</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                filled
                outlined
                elevation="0"
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.resep"
          @keydown.esc="dialog.resep = false"
          :fullscreen="dialog.fullscreen"
          v-if="dialog.resep"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                {{ form_resep.id === '' ? 'Tambah' : 'Ubah' }} Resep
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.resep = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Pilih Item" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Pilih Item
                    </div>

                    <v-autocomplete              
                      rounded
                      dense
                      filled
                      hide-details

                      color="#718EBF"
                      placeholder="Pilih Item"
                      :error-messages="errors"

                      class="mb-6"

                      :items="(items).filter(x => !(resep.filter(item => item)).map(x => (x.item_id !== form_resep.item_id ? x.item_id : '')).includes(x.id))"
                      item-text="name"
                      item-value="id"

                      v-model="form_resep.item_id"
                      
                      required
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form_resep.item_id !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                  <ValidationProvider
                    name="Quantity" 
                    rules="required|min_value:0" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Quantity
                    </div>

                    <v-currency-field              
                      rounded
                      dense
                      filled
                      hide-details
                      :suffix="items.find(x => x.id === form_resep.item_id) ? items.find(x => x.id === form_resep.item_id).satuan : ''"

                      color="#718EBF"
                      placeholder="Qty"
                      :error-messages="errors"

                      class="mb-6"
                      :auto-decimal-mode="false"
                      :decimal-length="2"
                      :allow-negative="false"
                      :min="0"

                      v-model="form_resep.qty"
                      
                      required
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form_resep.qty !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-currency-field>
                  </ValidationProvider>

                  <!-- <div class="body-2 mb-2">
                    Catatan
                  </div>
                  <v-textarea
                    filled
                    rounded
                    dense
                    rows="3"
                    
                    hide-details
                    
                    :color="set_color"
                    placeholder="Contoh. Tuliskan catatan disini . . ."

                    v-model="form.qty_diterima_note"
                    style="border-radius: 10px;">
                  </v-textarea> -->
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save_resep()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.resep = false; reset_resep();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete_topping"
          @keydown.esc="dialog.delete_topping = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete_topping = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">Topping</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletesTopping()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete_topping = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                filled
                outlined
                elevation="0"
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.topping"
          @keydown.esc="dialog.topping = false"
          :fullscreen="dialog.fullscreen"
          v-if="dialog.topping"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                {{ form_topping.id === '' ? 'Tambah' : 'Ubah' }} Topping
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.topping = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Pilih topping" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Pilih topping
                    </div>

                    <v-combobox              
                      rounded
                      dense
                      filled
                      hide-details

                      color="#718EBF"
                      placeholder="Pilih topping"
                      :error-messages="errors"

                      class="mb-6"

                      :items="(master_topping).filter(x => !(topping.filter(item => item)).map(x => (x.topping_id !== form_topping.topping_id ? x.topping_id : '')).includes(x.id))"
                      item-text="name"
                      item-value="id"
                      v-on:change="form_topping.topping_id = '';
                      master_topping.map(x => {
                        if (x.name === form_topping.topping_name.name) {
                          form_topping.topping_id = x.id
                        }
                      })
                      "

                      v-model="form_topping.topping_name"
                      
                      required
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form_topping.topping_name !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-combobox>
                  </ValidationProvider>

                  <!-- <div class="body-2 mb-2">
                    Catatan
                  </div>
                  <v-textarea
                    filled
                    rounded
                    dense
                    rows="3"
                    
                    hide-details
                    
                    :color="set_color"
                    placeholder="Contoh. Tuliskan catatan disini . . ."

                    v-model="form.qty_diterima_note"
                    style="border-radius: 10px;">
                  </v-textarea> -->

                  <div v-if="form_topping.topping_id === '' && (form_topping.topping_name !== '' && form_topping.topping_name !== null)">
                    <ValidationProvider
                      :name="`Satuan`" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="mb-2">
                        <span class="red--text">*</span>
                        Satuan
                      </div>

                      <v-autocomplete
                        v-on:keyup.enter="toTopping()"
                        
                        filled
                        rounded
                        dense

                        :color="set_color"
                        placeholder="Pilih Satuan"

                        hide-details
                        clearable

                        :items="satuan"
                        item-text="name"
                        item-value="name"
                        :item-color="set_color"
                        class="mb-6"

                        v-model="form_topping_add.satuan"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ errors[0] }}
                            </v-tooltip>
                          </div>
                          
                          <div v-if="form_topping_add.satuan !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-autocomplete>
                    </ValidationProvider>

                    <ValidationProvider
                      :name="`Harga Jual`" 
                      rules="required|min_value:0" 
                      v-slot="{ errors, valid }">
                      <div class="mb-2">
                        <span class="red--text">*</span>
                        Harga Jual
                      </div>

                      <v-currency-field
                        v-on:keyup.enter="toTopping()"
                        
                        filled
                        rounded
                        dense

                        :color="set_color"
                        placeholder="Harga Jual"
                        :error-messages="errors"

                        v-model="form_topping_add.selling_price"
                        required
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ errors[0] }}
                            </v-tooltip>
                          </div>
                          
                          <div v-if="form_topping_add.selling_price !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-currency-field>
                    </ValidationProvider>

                    <div v-if="user.is_count_ppn === '1'">
                      <div>
                        <v-checkbox v-model="form_topping_add.is_ppn">
                          <template v-slot:label>
                            <div class="black--text">
                              Gunakan PPN
                            </div>
                          </template>
                        </v-checkbox>
                      </div>
                    </div>

                    <v-card 
                      flat
                      class="mb-5"
                      style="">
                      <v-card-text>
                        <div class="fs-16 font-weight-bold black_one mb-6">
                          Gambar Produk
                        </div>
                        <v-row>
                          <v-col class="py-0" cols="12">
                            <uploadfolder
                              v-model="upload.image" 
                              style="height: 250px; width: 250px">
                              <div 
                                slot="activator"
                                class="cursor-pointer">
                                <v-card 
                                  flat
                                  height="250"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px;
                                        border: 2px solid #eaeaea; 
                                        border-style: dashed;">
                                  <div v-if="form_topping_add.image_url.length < 1">
                                    <v-icon v-if="!process.image"
                                      size="60" 
                                      color="#718EBF">
                                      mdi-cloud-upload-outline
                                    </v-icon>
            
                                    <v-progress-circular v-else
                                      indeterminate
                                      :color="set_color">
                                    </v-progress-circular>
                                  </div>
            
                                  <v-img v-else
                                    contain
                                    height="250"
                                    :src="form_topping_add.image_url" 
                                    :alt="form_topping_add.image_url"
                                    class="text-center d-flex align-center">
                                    <div 
                                      class="d-flex aling-center justify-center" 
                                      style="width: 100%; height: auto;">
                                      <v-icon v-if="!process.image"
                                        size="60" 
                                        color="white">
                                        mdi-cloud-upload-outline
                                      </v-icon>
            
                                      <v-progress-circular v-else
                                        indeterminate
                                        :color="set_color">
                                      </v-progress-circular>
                                    </div>
                                  </v-img>
                                </v-card>
                              </div>
                            </uploadfolder>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="toTopping()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.topping = false; reset_topping();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                :to="`/master-penjualan/item-penjualan-product`"
                flat
                color="transparent"
                style="width: 100%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="POS Amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Detail Produk
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1"
            style="min-height: calc(100vh - 220px);">
            <v-col 
              cols="12"
              class="py-0">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <v-card v-if="process.load && Object.keys(detail).length < 1"
                    flat
                    style="border-radius: 10px; border: 1px solid #E7E7E7;">
                    <v-card-text
                      class="pb-0 my-4" style="min-height: calc(100vh - 320px); display: flex; align-items: center; justify-content: center;">
                      <div class="text-center">
                        <div class="mb-2 title">
                          Mohon Tunggu...
                        </div>
                        <v-progress-circular
                          indeterminate
                        ></v-progress-circular>
                      </div>
                    </v-card-text>
                  </v-card>
    
                  <div v-if="!process.load && Object.keys(detail).length > 0" class="px-4">
                    <v-card 
                      flat
                      class="mb-0">

                      <div class="fs-18 font-weight-bold black_one ">
                        Informasi Produk
                      </div>
                      <!-- <v-card-text> -->
                        <v-row>
                          <v-col cols="12" md="3">
                            <v-card 
                              flat>
                              <div
                                style="height: 250px; width: 100%">
                                <div>
                                  <v-card 
                                    flat
                                    height="250"
                                    class="d-flex align-center justify-center"
                                    style="border-radius: 15px;
                                          border: 2px solid #eaeaea; 
                                          border-style: dashed;">
              
                                    <v-img
                                      contain
                                      height="250"
                                      :src="detail.image_url === '' ? require('@/assets/image/image_default.png') : detail.image_url" 
                                      alt="POS Amanata"
                                      class="text-center d-flex align-center">
                                      <!-- <div 
                                        class="d-flex aling-center justify-center" 
                                        style="width: 100%; height: auto;">
                                        <v-icon v-if="!process.image"
                                          size="60" 
                                          color="white">
                                          mdi-cloud-upload-outline
                                        </v-icon>
              
                                        <v-progress-circular v-else
                                          indeterminate
                                          :color="set_color">
                                        </v-progress-circular>
                                      </div> -->
                                    </v-img>
                                  </v-card>
                                </div>
                              </div>
                            </v-card>
                          </v-col>
                          <v-col cols="12" md="9">
                            <v-card 
                              flat
                              class="mb-5"
                              style="border-radius: 10px; border: 1px solid #E7E7E7;">
                              <v-card-text>
                                <v-row>
                                  <v-col class="py-0" cols="12">
                                    <div class="mb-6">
                                      <div>
                                        <div>
                                          Nama Produk
                                        </div>
                                        <div class="fs-16 font_weight_600 black_one">
                                          {{ detail.name }}
                                        </div>
                                      </div>
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="6">
                                    <div class="mb-6">
                                      <div>
                                        <div>
                                          Type
                                        </div>
                                        <div class="fs-16 font_weight_600 black_one text-capitalize">
                                          {{ detail.type }}
                                        </div>
                                      </div>
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="6">
                                    <div class="mb-6" v-if="detail.type === 'layanan'">
                                      <div>
                                        <div>
                                          Durasi Layanan
                                        </div>
                                        <div class="fs-16 font_weight_600 black_one text-capitalize">
                                          {{ detail.duration_minutes }} Menit
                                        </div>
                                      </div>
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="6">
                                    <div class="mb-6">
                                      <div>
                                        <div>
                                          Nama Kategori
                                        </div>
                                        <div class="fs-16 font_weight_600 black_one text-capitalize">
                                          {{ detail.category_name }}
                                        </div>
                                      </div>
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="6">
                                    <div class="mb-6">
                                      <div>
                                        <div>
                                          Satuan
                                        </div>
                                        <div class="fs-16 font_weight_600 black_one text-capitalize">
                                          {{ detail.satuan }}
                                        </div>
                                      </div>
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="12">
                                    <div class="mb-6">
                                      <div>
                                        <div>
                                          Deskripsi
                                        </div>
                                        <div class="fs-16 font_weight_600 black_one">
                                          {{ detail.desc === '' ? '-' : detail.desc }}
                                        </div>
                                      </div>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col cols="12" md="4" v-if="detail.type !== 'layanan'">
                            <v-row>
                              <v-col cols="12" md="12" class="py-0">
                                <div class="d-flex">
                                  <div class="fs-18 font-weight-bold black_one mb-0">
                                    Informasi Stok
                                  </div>
                                  <div class="ml-auto d-flex align-center">
                                    <v-btn
                                      @click="dialog.form = true; message.success = ''; message.error = ''; message.status = 'tambah'; reset();"
                                      :disabled="process.form"
                                      color="primary"
                                      elevation="0"
                                      class="body-2 white--text text-capitalize d-flex align-center ml-4"
                                      style="border-radius: 10px; font-weight: 600;">
                                      <v-icon 
                                        size="20">
                                        mdi-plus-circle
                                      </v-icon>
                    
                                      <span
                                        class="ml-2">
                                        Stok
                                      </span>
                                    </v-btn>
                    
                                    <v-btn
                                      @click="dialog.form = true; message.success = ''; message.error = ''; message.status = 'kurang'; reset();"
                                      :disabled="process.form"
                                      color="orange"
                                      elevation="0"
                                      class="body-2 white--text text-capitalize d-flex align-center ml-4"
                                      style="border-radius: 10px; font-weight: 600;">
                                      <v-icon 
                                        size="20">
                                        mdi-minus-circle
                                      </v-icon>
                    
                                      <span
                                        class="ml-2">
                                        Stok
                                      </span>
                                    </v-btn>
                                  </div>
                                </div>
                                <!-- <v-divider class="my-2"></v-divider> -->
                              </v-col>
                              <v-col cols="12" md="12">
                                <v-card
                                  flat
                                  style="border-radius: 10px; background-color: #FFE0B2">
                                  <v-card-text>
                                    <div class="mb-1">
                                      Minimal Stok
                                    </div>
                                    <div class="fs-20 font_weight_600 black_one">
                                      {{ detail.stock_min*1 }}
                                    </div>
                                  </v-card-text>
                                </v-card>  
                              </v-col>
                              <v-col cols="12" md="12" class="pb-0">
                                <v-card
                                  flat
                                  style="border-radius: 10px; background-color: #B3E5FC">
                                  <v-card-text>
                                    <div class="d-flex" style="width: 100%;">
                                      <div style="width: 33%;">
                                        <div class="mb-1">
                                          Total Stok
                                        </div>
                                        <div class="fs-20 font_weight_600 black_one">
                                          {{ (detail.stock*1) + (detail.stock_in_order*1) }}
                                        </div>
                                      </div>

                                      <div style="width: 33%;">
                                        <div class="mb-1">
                                          Stok
                                        </div>
                                        <div class="fs-20 font_weight_600 black_one">
                                          {{ detail.stock*1 }}
                                        </div>
                                      </div>

                                      <div style="width: 33%;">
                                        <div class="mb-1">
                                          Stok in Order
                                        </div>
                                        <div class="fs-20 font_weight_600 black_one">
                                          {{ detail.stock_in_order*1 }}
                                        </div>
                                      </div>
                                    </div>
                                  </v-card-text>
                                </v-card>  
                              </v-col>
                            </v-row>
                          </v-col>

                          <v-col cols="12" :md="detail.type === 'layanan' ? 6 : 4">
                            <v-row>
                              <v-col cols="12" md="12" class="py-0">
                                <div class="fs-18 font-weight-bold black_one mb-2">
                                  Informasi Harga
                                </div>
                                <!-- <v-divider class="my-2"></v-divider> -->
                              </v-col>
                              <v-col cols="12" md="12">
                                <v-card
                                  flat
                                  style="border-radius: 10px; background-color: #B2EBF2">
                                  <v-card-text>
                                    <div class="mb-1">
                                      Harga Beli
                                    </div>
                                    <div class="fs-20 font_weight_600 black_one">
                                      {{ detail.hpp | price }}
                                    </div>
                                  </v-card-text>
                                </v-card>  
                              </v-col>
                              <v-col cols="12" md="12" class="pb-0">
                                <v-card
                                  flat
                                  style="border-radius: 10px; background-color: #F8BBD0">
                                  <v-card-text>
                                    <div class="mb-1">
                                      Harga Jual
                                    </div>
                                    <div class="fs-20 font_weight_600 black_one">
                                      {{ detail.selling_price | price }}
                                    </div>
                                  </v-card-text>
                                </v-card>  
                              </v-col>
                            </v-row>
                          </v-col>

                          <v-col cols="12" :md="detail.type === 'layanan' ? 6 : 4">
                            <v-row>
                              <v-col cols="12" md="12" class="py-0">
                                <div class="fs-18 font-weight-bold black_one mb-2">
                                  Informasi Diskon
                                </div>
                                <!-- <v-divider class="my-2"></v-divider> -->
                              </v-col>
                              <v-col cols="12" md="12">
                                <v-card
                                  flat
                                  style="border-radius: 10px; background-color: #FFCDD2">
                                  <v-card-text>
                                    <div class="mb-1">
                                      Diskon (Persen)
                                    </div>
                                    <div class="fs-20 font_weight_600 black_one">
                                      {{ detail.discount_percent*1 }} %
                                    </div>
                                  </v-card-text>
                                </v-card>  
                              </v-col>
                              <v-col cols="12" md="12" class="pb-0">
                                <v-card
                                  flat
                                  style="border-radius: 10px; background-color: #C8E6C9">
                                  <v-card-text>
                                    <div class="mb-1">
                                      Diskon (Rupiah)
                                    </div>
                                    <div class="fs-20 font_weight_600 black_one">
                                      {{ detail.discount_value*1 | price }}
                                    </div>
                                  </v-card-text>
                                </v-card>  
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      <!-- </v-card-text> -->
                    </v-card>

                    <!-- <v-card 
                      flat
                      class="mb-5"
                      style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                      <v-card-text>
                        <div class="fs-18 font-weight-bold black_one mb-6">
                          Informasi Stok
                        </div>
                        <v-row>
                          <v-col class="py-0" cols="6">
                            <div class="mb-6">
                              <div>
                                <div>
                                  Stok Minimal
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ detail.stock_min*1 }}
                                </div>
                              </div>
                            </div>
                          </v-col>
                          <v-col class="py-0" cols="6">
                            <div class="mb-6">
                              <div>
                                <div>
                                  Stok
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ detail.stock*1 }}
                                </div>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card> -->
                    <!-- <v-row>
                      <v-col cols="12" md="6">
                        <v-card 
                          flat
                          class="mb-5"
                          style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                          <v-card-text>
                            <div class="fs-18 font-weight-bold black_one mb-6">
                              Informasi Harga
                            </div>
                            <v-row>
                              <v-col class="py-0" cols="6">
                                <div class="mb-6">
                                  <div>
                                    <div>
                                      Harga Beli
                                    </div>
                                    <div class="fs-16 font_weight_600 black_one">
                                      {{ detail.hpp | price }}
                                    </div>
                                  </div>
                                </div>
                              </v-col>
                              <v-col class="py-0" cols="6">
                                <div class="mb-6">
                                  <div>
                                    <div>
                                      Harga Jual
                                    </div>
                                    <div class="fs-16 font_weight_600 black_one">
                                      {{ detail.selling_price | price }}
                                    </div>
                                  </div>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-card 
                          flat
                          class="mb-5"
                          style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                          <v-card-text>
                            <div class="fs-18 font-weight-bold black_one mb-6">
                              Informasi Diskon
                            </div>
                            <v-row>
                              <v-col class="py-0" cols="6">
                                <div class="mb-6">
                                  <div>
                                    <div>
                                      Diskon (Persen)
                                    </div>
                                    <div class="fs-16 font_weight_600 black_one">
                                      {{ detail.discount_percent*1 }} %
                                    </div>
                                  </div>
                                </div>
                              </v-col>
                              <v-col class="py-0" cols="6">
                                <div class="mb-6">
                                  <div>
                                    <div>
                                      Diskon (Rupiah)
                                    </div>
                                    <div class="fs-16 font_weight_600 black_one">
                                      {{ detail.discount_value*1 | price }}
                                    </div>
                                  </div>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>


                    <v-card 
                      flat
                      class="mb-5"
                      style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                      <v-card-text>
                        <div class="fs-18 font-weight-bold black_one mb-6">
                          Gambar Produk
                        </div>
                        <v-row>
                          <v-col class="py-0" cols="12">
                            <div
                              style="height: 250px; width: 250px">
                              <div>
                                <v-card 
                                  flat
                                  height="250"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px;
                                        border: 2px solid #eaeaea; 
                                        border-style: dashed;">
            
                                  <v-img
                                    contain
                                    height="250"
                                    :src="detail.image_url" 
                                    :alt="detail.image_url"
                                    class="text-center d-flex align-center">
                                    <div 
                                      class="d-flex aling-center justify-center" 
                                      style="width: 100%; height: auto;">
                                      <v-icon v-if="!process.image"
                                        size="60" 
                                        color="white">
                                        mdi-cloud-upload-outline
                                      </v-icon>
            
                                      <v-progress-circular v-else
                                        indeterminate
                                        :color="set_color">
                                      </v-progress-circular>
                                    </div>
                                  </v-img>
                                </v-card>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card> -->
                  </div>
                </v-form>
              </ValidationObserver>


              <v-card flat>
                <v-card-text>
                  <v-divider class="mb-4"></v-divider>
                  <v-row>
                    <v-col cols="12" md="12" class="py-0">
                      <div class="">
                        <div class="fs-18 font-weight-bold black_one mb-0">
                          Toping
                        </div>
                        <div class="d-flex align-center pt-1">
                          <v-btn
                            @click="dialog.topping = true; message.success = ''; message.error = ''; reset_topping();"
                            :disabled="process.form"
                            color="green"
                            small
                            elevation="0"
                            class="fs-13 white--text text-capitalize d-flex align-center"
                            style="border-radius: 6px; font-weight: 600;">
                            <v-icon 
                              size="18">
                              mdi-plus-circle
                            </v-icon>
          
                            <span
                              class="ml-2">
                              Tambah
                            </span>
                          </v-btn>
                        </div>
                      </div>

                      <div class="mt-1">
                        <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                          <tr>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">Aksi</th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">Nama</th>
                            <!-- <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">Qty</th> -->
                          </tr>
                          <tr v-for="(item, index) in topping" :key="index">
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100px; min-width: 100px; max-width: 100px;" class="black--text">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="dialog.topping = true; message.success = ''; message.error = ''; reset_topping(item);"
                                    
                                    min-width="24" min-height="24"
                                    x-small
                                    rounded
                                    color="primary"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="15">mdi-pencil</v-icon>
                                  </v-btn>
                                </template>

                                <span>Ubah</span>
                              </v-tooltip>
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="toDeleteTopping(item.id);"
                                    
                                    min-width="24" min-height="24"
                                    x-small
                                    rounded
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="15">mdi-trash-can-outline</v-icon>
                                  </v-btn>
                                </template>

                                <span>Hapus</span>
                              </v-tooltip>
                            </td>
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                              {{ item.topping_name }}
                            </td>
                            <!-- <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                              {{ item.qty }} {{ items.find(x => x.id === item.item_id) ? items.find(x => x.id === item.item_id).satuan : '' }}
                            </td> -->
                          </tr>
                        </table>
                      </div>

                      <v-card-text
                        v-if="topping.length === 0"
                        class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                        <div class="text-center">
                          <div class="mt-3 fs-16">
                            Belum ada data
                          </div>
                        </div>
                      </v-card-text>
                      <!-- <v-divider class="my-2"></v-divider> -->
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card flat>
                <v-card-text>
                  <v-divider class="mb-4"></v-divider>
                  <v-row>
                    <v-col cols="12" md="12" class="py-0">
                      <div class="">
                        <div class="fs-18 font-weight-bold black_one mb-0">
                          Resep
                        </div>
                        <div class="d-flex align-center pt-1">
                          <v-btn
                            @click="dialog.resep = true; message.success = ''; message.error = ''; reset_resep();"
                            :disabled="process.form"
                            color="green"
                            small
                            elevation="0"
                            class="fs-13 white--text text-capitalize d-flex align-center"
                            style="border-radius: 6px; font-weight: 600;">
                            <v-icon 
                              size="18">
                              mdi-plus-circle
                            </v-icon>
          
                            <span
                              class="ml-2">
                              Tambah
                            </span>
                          </v-btn>
                        </div>
                      </div>

                      <div class="mt-1">
                        <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                          <tr>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">Aksi</th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">Nama</th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">Qty</th>
                          </tr>
                          <tr v-for="(item, index) in resep" :key="index">
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100px; min-width: 100px; max-width: 100px;" class="black--text">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="dialog.resep = true; message.success = ''; message.error = ''; reset_resep(item);"
                                    
                                    min-width="24" min-height="24"
                                    x-small
                                    rounded
                                    color="primary"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="15">mdi-pencil</v-icon>
                                  </v-btn>
                                </template>

                                <span>Ubah</span>
                              </v-tooltip>
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="toDelete(item.id);"
                                    
                                    min-width="24" min-height="24"
                                    x-small
                                    rounded
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="15">mdi-trash-can-outline</v-icon>
                                  </v-btn>
                                </template>

                                <span>Hapus</span>
                              </v-tooltip>
                            </td>
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;" class="black--text">
                              {{ item.item_name }}
                            </td>
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                              {{ item.qty }} {{ items.find(x => x.id === item.item_id) ? items.find(x => x.id === item.item_id).satuan : '' }}
                            </td>
                          </tr>
                        </table>
                      </div>

                      <v-card-text
                        v-if="resep.length === 0"
                        class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                        <div class="text-center">
                          <div class="mt-3 fs-16">
                            Belum ada data
                          </div>
                        </div>
                      </v-card-text>
                      <!-- <v-divider class="my-2"></v-divider> -->
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>


              <v-card flat class="" v-if="detail.type !== 'layanan'">
                <v-card-text>
                  <v-divider class="mb-4"></v-divider>
                  <div class="fs-18 font-weight-bold black_one mb-4">
                    Riwayat Stok
                  </div>
                  <v-row>
                    <v-col 
                      cols="12"
                      class="py-0">
                      <v-card 
                        flat
                        style="border-radius: 10px; border: 1px solid #E7E7E7;">
                        <v-data-table
                          v-model="selected.row"
                          ref="table-grid"
                          class="table-grid"
                          :height="`calc(100vh - ${pagination.total_data > 0 ? '470px' : '248px'})`"
                          :show-select="checkbox"
                          :single-select="true"
                          :loading="process.table"
                          loading-text="Sedang memuat data . . ."
                          loader-height="5"
                          no-results-text="Belum ada data"
                          :options.sync="options"
                          :headers="configHeaders"
                          :items="list"
                          :items-per-page="100"
                          item-key="id"
                          @click:row="rowClick"
                          @toggle-select-all="handleToggleAll($event)"
                          @dblclick:row="doubleClick"
                          hide-default-footer>
                          <template
                            v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                              v-slot:[`item.${header.value}`]="{ value }">
                            <div
                              v-bind:key="header.value">
                              <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                                {{ rowFormat(header.format, value) }} 
                              </div>
  
                              <div v-if="header.format === 'link'"
                                class="cursor-pointer">
                                
                              </div>
                
                              <div v-if="header.format === 'regex'">
                                <span
                                  class="two-line">
                                  {{ rowFormat(header.format, value) }}
                                </span>
                              </div>
                
                              <div v-if="header.format === 'image'"
                                class="ma-4">
                                <v-avatar
                                  size="60"
                                  tile
                                  style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                  <v-img 
                                    contain
                                    width="100%"
                                    height="100%"
                                    alt="POS Amanata" 
                                    :src="value !== '' ? value : require('@/assets/image/member_default.png')"
                                    class="ma-auto">
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height"
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          size="20"
                                          indeterminate 
                                          :color="set_color">
                                        </v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                </v-avatar>
                              </div>
  
                              <div v-if="header.format === 'image_potrait'"
                                class="ma-4">
                                <v-img 
                                  contain
                                  width="100"
                                  height="125"
                                  alt="POS Amanata" 
                                  :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                  class="ma-auto"
                                  style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        size="20"
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                              </div>
  
                              <div v-if="header.format === 'image_landscape'"
                                class="ma-4">
                                <v-img 
                                  contain
                                  width="200"
                                  height="125"
                                  alt="POS Amanata" 
                                  :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                  class="ma-auto"
                                  style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        size="20"
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                              </div>
  
                              <div v-if="header.format === 'action'">
  
                                
                              </div>
                            </div>
                          </template>
  
                          <template v-slot:[`item.index`]="{ index }">
                            {{ lastIndex + index }}
                          </template>
  
                          <v-progress-linear 
                            v-show="process.load" 
                            slot="progress" 
                            color="white" 
                            indeterminate>
                          </v-progress-linear>
                        </v-data-table>
  
                        <pagination v-if="pagination.total_data > 0"
                          @changePage="fetch($event)" 
                          @reloadPage="fetch($event)" 
                          :model="pagination" :display="paginationList"/>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 px-5">
            <v-col 
            cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <div v-if="message.error.length > 0"
                class="text-center mx-6 my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
              <v-space/>
              
              <v-btn
                :to="`/master-penjualan/item-penjualan-product`"
                :disabled="process.form"
                color="red"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon 
                  size="20">
                  mdi-progress-close
                </v-icon>

                <span
                  class="ml-2">
                  Kembali
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        item: [],
        checkbox: false,
        dialog: {
          form: false,
          fullscreen: false,
          resep: false,
          delete: false,
          topping: false,
          delete_topping: false
        },
        menu: {
          
        },
        modalTime: {
          
        },
        total_nominal: 0,
        form: {},
        detail: {},
        categoty_id: '',
        product: [],
        category: [],
        allCategory: [],
        satuan: [],
        menu2: false,
        menu1: false,
        location: [],
        show: false,
        paginationList: {},
        lastIndex: 0,
        limit: 20,
        options: {},
        headers: [],
        list: [],
        detail_item: [],
        pagination: {},
        selected: {
          row: [],
          freeze: [],
          delete: [],
          reset: [],
          role: [],
          form: 0
        },
        items: [],
        resep: [],
        upload: {
          image: null
        },
        master_topping: [],
        topping: [],

        form_resep: {
          id: '',
          outlet_id: '',
          item_sales_id: '',
          item_id: '',
          qty: ''
        },
        form_topping: {
          id: '',
          outlet_id: '',
          product_id: '',
          topping_id: '',
          topping_name: ''
        },

        satuan: [],

        form_topping_add: {
          name: '',
					satuan: '',
					image_url: '',
          selling_price: '',
					outlet_id: '',
          is_ppn: false
        },

        process: {
          form: false,
          load: false,

          image: false,
          table: false,
          delete: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      },
      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form_topping_add.image_url = this.upload.image.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    mounted () {
      this.fetchDetail()
      this.fetchItems()
      this.fetchResep()
      this.fetchProductTopping()
      this.fetchTopping()
      this.fetchSatuan()
    },
    methods: {
      async fetchDetail (data) {
        this.process.load = true
        let params = {
          outlet_id: this.outlet.outlet_id,
          limit: 1000000000,
          id: this.$route.params.id
        }
        
        await get('pos/item_sales/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail = res.results.data
            this.process.load = false
          }
        })
      },
      async fetchResep (data) {
        let params = {
          outlet_id: this.outlet.outlet_id,
          limit: 1000000000,
          item_sales_id: this.$route.params.id
        }
        
        await get('pos/recipe/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.resep = []
            res.results.data.map((item) => {
              this.resep.push({ 
                ...item,
                qty: (item.qty*1).toString().split('.').join(','),
              })
            })
          }
        })
      },
      async fetchProductTopping (data) {
        let params = {
          outlet_id: this.outlet.outlet_id,
          limit: 1000000000,
          product_id: this.$route.params.id
        }
        
        await get('pos/item_topping/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.topping = []
            res.results.data.map((item) => {
              this.topping.push({ 
                ...item
              })
            })
          }
        })
      },
      async fetchItems () {
        let params = {
          limit: 100000000000,
          outlet_id: this.outlet.outlet_id
        }

        await get(`pos/pembelian/item/data_last_child`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.items = res.results.data
          }
        })
      },

      async fetchTopping () {
        let params = {
          limit: 100000000000,
          outlet_id: this.outlet.outlet_id
        }

        await get(`pos/topping/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.master_topping = res.results.data
          }
        })
      },

      async fetchSatuan (data) {
        let params = {
          // outlet_id: this.outlet.outlet_id,
          limit: 1000000000
        }
        
        await get('pos/satuan/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.satuan = res.results.data
          }
        })
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.table = true
        this.paginationList = pagination

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? '-datetime' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          item_sales_id: this.$route.params.id
        }

        await get(`pos/item_sales_stock_log/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            console.log(res.results.data)
            // this.items = []
            // this.detail_item = res.results.data
            this.detail_item = []
            res.results.data.map((item) => {
              this.detail_item.push({ 
                ...item,
                qty_in: item.qty_in*1,
                qty_out: item.qty_out*1,
              })
            })
            // this.detail_item.map((item) => {
            //   this.fetchItem(item.item_id)
            // })
            // for (let i = 0; i < this.detail_item.length; i++) {
            //   this.fetchItem(this.detail_item[i].item_id)
            // }

            this.headers = [
              // {
              //   text: 'Aksi',
              //   width: '180px',
              //   value: 'id',
              //   freeze: true,
              //   hide: false,
              //   align: 'center',
              //   format: 'action'
              // },
              // {
              //   text: 'Nomor Induk Pegawai',
              //   width: '200px',
              //   value: 'nip',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Tanggal',
                width: '250px',
                value: 'datetime',
                freeze: false,
                hide: false,
                format: 'datetime'
              },
              {
                text: 'Stok Masuk',
                width: '200px',
                value: 'qty_in',
                color: 'blue',
                freeze: false,
                hide: false
              },
              {
                text: 'Stok Keluar',
                width: '200px',
                value: 'qty_out',
                color: 'red',
                freeze: false,
                hide: false
              },
              {
                text: 'Catatan',
                width: '250px',
                value: 'note',
                freeze: false,
                hide: false
              },
            ]
  
            this.list = this.detail_item

              
            this.pagination = res.results.pagination
  
            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1
            this.process.table = false

          }
        })
      },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },
      reset () {
        this.form = {
          qty: 0,
          note: ''
        }
      },
      
      reset_resep (item) {
        if (this.$refs.form) this.$refs.form.reset()

        this.form_resep = {
          id: item !== undefined ? item.id : '',
          outlet_id: this.outlet.outlet_id,
          item_sales_id: this.$route.params.id,
          item_id: item !== undefined ? item.item_id : '',
          qty: item !== undefined ? (item.qty*1) : ''
        }

        this.process.form = false

        this.message.error = ''
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true
          // this.detail.status = 'Selesai'
          // this.dialog.selesai = false

          // let url = this.form.id === '' ? 'pos/pembelian/category_item/add' : 'pos/pembelian/category_item/update'

          // SAVE TO REST API
          await post('pos/Item_sales_stock_log/update', {
            data: {
              item_sales_id: this.$route.params.id,
              qty: this.form.qty,
              aksi: this.message.status,
              note: this.form.note
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message
              this.dialog.form = false


              this.dialog.fullscreen = false

              this.fetchDetail()
              this.fetch(this.paginationList)

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      async save_resep () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true
          // this.detail.status = 'Selesai'
          // this.dialog.selesai = false

          // let url = this.form.id === '' ? 'pos/pembelian/category_item/add' : 'pos/pembelian/category_item/update'

          // SAVE TO REST API
          let url = this.form_resep.id === '' ? 'pos/recipe/add' : 'pos/recipe/update'
          await post(`${url}`, {
            data: {
              ...this.form_resep,
              qty: (this.form_resep.qty*1).toString().split(',').join('.')
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false
              this.dialog.resep = false

              this.dialog.snackbar = true
              this.message.success = res.message
              this.dialog.form = false


              this.dialog.fullscreen = false

              // this.fetchDetail()
              // this.fetch(this.paginationList)
              this.fetchResep()
              this.reset_resep()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`pos/recipe/delete`, {
          data: {
            id: this.selected.delete[0],
            outlet_id: this.outlet.outlet_id
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            // if (this.search === '' && this.search === null) {
            //   this.fetch(this.paginationList)
            // } else {
            //   if (this.selected_par_id === '0') {
            //     this.fetch(this.paginationList)
            //   } else {
            //     this.fetchLastChild(this.paginationList)
            //   }
            // }
            this.fetchResep()
          } else {
            this.message.error = res.message
          }
        })
      },

      reset_topping (item) {
        if (this.$refs.form) this.$refs.form.reset()

        this.form_topping = {
          id: item !== undefined ? item.id : '',
          outlet_id: this.outlet.outlet_id,
          product_id: this.$route.params.id,
          topping_id: item !== undefined ? item.topping_id : '',
          topping_name: item !== undefined ? item.topping_name : '',
          topping_is_ppn: item !== undefined ? item.topping_is_ppn === '1' ? true : false : false
        }

        this.form_topping_add = {
          name: '',
          satuan: '',
          image_url: '',
          selling_price: '',
          outlet_id: '',
          is_ppn: false
        }

        this.process.form = false

        this.message.error = ''
      },

      toTopping () {
        if(this.form_topping.topping_id === '' && (this.form_topping.topping_name !== '' && this.form_topping.topping_name !== null)) {
          this.toAddTopping()
        } else {
          this.save_topping()
        }
      },
      async toAddTopping () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = 'pos/topping/add'

          this.form_topping_add.name = this.form_topping.topping_name

          this.form_topping_add.outlet_id = this.outlet.outlet_id

          // SAVE TO REST API
          await post(url, {
            data: {
              ...this.form_topping_add,
              is_ppn: this.form_topping_add.is_ppn ? '1' : '0'
            }
          })
          .then(response => {
            let res = response.data
            
            // this.process.form = false

            if (res.status === 200) {
              this.form_topping.topping_id = res.results.data.topping_id
              this.save_topping()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async save_topping () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true
          // this.detail.status = 'Selesai'
          // this.dialog.selesai = false

          // let url = this.form.id === '' ? 'pos/pembelian/category_item/add' : 'pos/pembelian/category_item/update'

          // SAVE TO REST API
          let url = this.form_topping.id === '' ? 'pos/item_topping/add' : 'pos/item_topping/update'
          await post(`${url}`, {
            data: {
              ...this.form_topping,
              topping_is_ppn: this.form_topping_add.is_ppn ? '1' : '0'
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false
              this.dialog.topping = false

              this.dialog.snackbar = true
              this.message.success = res.message
              this.dialog.form = false


              this.dialog.fullscreen = false

              // this.fetchDetail()
              this.fetchProductTopping()
              this.reset_topping()
              // this.fetch(this.paginationList)

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },


      toDeleteTopping (id) {
        this.selected.delete = [id]

        this.dialog.delete_topping = true
      },
      async deletesTopping () {
        this.message.error = ''

        this.process.delete = true

        await post(`pos/item_topping/delete`, {
          data: {
            id: this.selected.delete[0],
            outlet_id: this.outlet.outlet_id
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete_topping = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            // if (this.search === '' && this.search === null) {
            //   this.fetch(this.paginationList)
            // } else {
            //   if (this.selected_par_id === '0') {
            //     this.fetch(this.paginationList)
            //   } else {
            //     this.fetchLastChild(this.paginationList)
            //   }
            // }
            this.fetchProductTopping()
          } else {
            this.message.error = res.message
          }
        })
      },
    }
  }
</script>